var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 67,
    viewBox: "0 0 100 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.0695 58.5198C87.6177 58.5198 91.339 54.7985 91.339 50.2504V8.90322C91.339 4.35503 87.6177 0.633789 83.0695 0.633789H16.9141C12.3659 0.633789 8.64467 4.35503 8.64467 8.90322V50.2504C8.64467 54.7985 12.3659 58.5198 16.9141 58.5198H4.50996C2.23587 58.5198 0.375244 60.3804 0.375244 62.6545C0.375244 64.9286 2.23587 66.7892 4.50996 66.7892H95.4737C97.7478 66.7892 99.6084 64.9286 99.6084 62.6545C99.6084 60.3804 97.7478 58.5198 95.4737 58.5198H83.0695ZM21.0488 8.90322H78.9348C81.2089 8.90322 83.0695 10.7638 83.0695 13.0379V46.1157C83.0695 48.3897 81.2089 50.2504 78.9348 50.2504H21.0488C18.7747 50.2504 16.9141 48.3897 16.9141 46.1157V13.0379C16.9141 10.7638 18.7747 8.90322 21.0488 8.90322Z",
    fill: "#2165A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportDevice);
export default __webpack_public_path__ + "static/media/import-device.8161c12c74ee275794b6703f72062e12.svg";
export { ForwardRef as ReactComponent };